import { render, staticRenderFns } from "./BasePaymentSettingsForm.vue?vue&type=template&id=4ef07d92&"
import script from "./BasePaymentSettingsForm.vue?vue&type=script&lang=js&"
export * from "./BasePaymentSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports